const PIE_COLORS = [
  "hsl(38, 95%, 53%)",
  "hsl(258, 90%, 66%)",
  "hsl(152, 62%, 45%)",
  "hsl(28, 90%, 55%)",
  "hsl(199, 89%, 55%)",
  "hsl(340, 82%, 62%)",
  "hsl(173, 70%, 45%)",
  "hsl(280, 70%, 66%)",
] as const;

export { PIE_COLORS };
